/*
 * [Ref] - Denotes Pseudo Code Reference  
 *  
 * This component is the Forgot Password page component. The component displays the Forgot Password page details.
 * 
 * App Name: SDI-Walmart
 * Author: M.Sushmitha
 * Created Date: 09/01/2020 
 */
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import swal from 'sweetalert';
/*
 * FP_PC_01
 * */
import * as ForgotPasswordAction from '../actions/ForgotPasswordAction';
import ForgotPasswordStore from '../stores/ForgotPasswordStore';
import SDIConstants from '../SDIConstants';
import * as $ from 'jquery';
import { withTranslation, Trans } from 'react-i18next'
import * as CookieService from '../CookieService';
class ForgotPassword extends Component {
    /**
     * FP_PC_03
     * Declare a “constructor” method with “props” as its parameters.
     */
    constructor(props) {
        super(props);
        this.validation_Check = this.validation_Check.bind(this)
        this.restrictEnterAndTab = this.restrictEnterAndTab.bind(this)
        /*
         * FP_PC_04
         * */
        this.state = {
            ForgotPassword: true,
            LoginUserId: "",
            ResponseMessage: "",
            isValid: true
        }
    }
    /*
         * FP_PC_05
         * */
    componentDidMount() {
        let displayText = CookieService.getLocalStorageValues("displayText");
        let isredirect = CookieService.getLocalStorageValues("isredirect");
        let resultMessage = CookieService.getLocalStorageValues("resultMessage");
        this.props.DisplayOutageData(isredirect, displayText, resultMessage);

        const params = new URLSearchParams(window.location.search)
        console.log(params)
        let UserId = []
        for (const param of params) {
            UserId = param
            console.log(param)
        }
        var pattern = SDIConstants.emailRegex
        if (!pattern.test(UserId[1])) {
            this.setState({ LoginUserId: UserId[1] })
        } else {
            $('#EmailID').val(UserId[1])
        }
        ForgotPasswordStore.on("Forgot_Password", this.validation_Check);

    }
    componentWillUnmount() {
        ForgotPasswordStore.removeListener("Forgot_Password", this.validation_Check);
    }

    backToLoginClick = () => {
        
        CookieService.updateLocalStorageValues("ShowNormalLogin", true);
        CookieService.updateLocalStorageValues("BackFromForgotOrChgPass", true);
        this.props.history.push({
            pathname: '/'
        });
    }
    /*
         * FP_PC_07
         * */

    resetPwdBtn_Clk = () => {
        let UserId = $('#UserId').val()
        let EmailId = $('#EmailID').val()
        let msg = "" //WW-1036_PC_01
        let isValid = true
        if (UserId == "" || UserId == null || EmailId == "" || EmailId == null) {
            isValid = false;
            // document.getElementById("ErrorMsg2").innerText = "Please enter required fields";
            msg = "Please enter required fields"
        }
        else if (UserId == "" || UserId == null) {
            isValid = false;
            //document.getElementById("ErrorMsg2").innerText = "Please enter user id";
            msg = "Please enter user id"
        }
        else if (EmailId == "" || EmailId == null) {
            isValid = false;
            // document.getElementById("ErrorMsg2").innerText = "Please enter email id";
            msg = "Please enter email id"
        }
        else if (EmailId != "" || EmailId != null) {
            var pattern = new RegExp(/^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i);
            if (!pattern.test(EmailId)) {
                isValid = false;

                //document.getElementById("ErrorMsg2").innerHTML = "If the data provided is correct, you will receive an email with password reset instructions";
                msg = "If the data provided is correct, you will receive an email with password reset instructions"

            }
            else {
                //[9/12/22], PC_FP_01, WAL - Forget password - wrong error msg display, Dhevanesam R
                // document.getElementById("ErrorMsg2").innerHTML = "";
                msg = "";
            }
        }
        else {
            // document.getElementById("ErrorMsg2").innerHTML = "";
            msg = "";
        }
        this.setState({ ResponseMessage: msg });
        if (isValid == true) {
            $('#forgetpassword').modal('show');
        }

        this.setState({
            isValid: isValid
        });
    }
    forgetPasswordOk_Clk = () => {
        if (this.state.isValid) {
            //var person = prompt("Are you sure you want to reset your password?");
            
            let UserId = $('#UserId').val()
            let EmailId = $('#EmailID').val()
            let ForgotPasswordBo = {
                USERID: UserId,
                EmailID: EmailId,
                Session_PW: "N",
            }
            ForgotPasswordAction.RSTPwdBtn_Clk(ForgotPasswordBo)
            $(`#${SDIConstants.SDILoader}`).removeClass('hide');


        }
    }

    /*
         * FP_PC_08
         * */
    validation_Check = () => {
        
        $(`#${SDIConstants.SDILoader}`).addClass('hide');
        let Validate = JSON.parse(ForgotPasswordStore.ForgotPasswordList);
        console.log("Validate", Validate)
        let MesageTable = Validate.MessageTable
        if (MesageTable[0].Response_Message != null) {
            //    document.getElementById("ErrorMsg2").innerHTML = MesageTable[0].Response_Message
            this.setState({ ResponseMessage: MesageTable[0].Response_Message })
        }
        //else if (MesageTable[0].EmailID_Not_Matched != null) {
        //    document.getElementById("ErrorMsg2").innerHTML = MesageTable[0].EmailID_Not_Matched
        //}
        //else if (MesageTable[0].Invalid_EmailID != null) {
        //    document.getElementById("ErrorMsg2").innerHTML = MesageTable[0].Invalid_EmailID
        //}
        //else if (MesageTable[0].NOTFOUND != null) {
        //    document.getElementById("ErrorMsg2").innerHTML = MesageTable[0].NOTFOUND
        //}
        //else if (MesageTable[0].Password_Not_Exist != null) {
        //    document.getElementById("ErrorMsg2").innerHTML = MesageTable[0].Password_Not_Exist
        //}
        else {
            swal({
                allowOutsideClick: false,
                closeOnClickOutside: false,
                text: MesageTable[0].Response_Message
            });

            this.props.history.push({
                pathname: '/',
            });
        }
    }
    restrictEnterAndTab = (event) => {
        var keyCode = event.keyCode || event.which;

        // Check for Enter key (keyCode 13) or Tab key (keyCode 9) or space key (keyCode 32) 
        if (keyCode === 13 || keyCode === 9 || keyCode === 32) {
            event.preventDefault();
        }

    }
    handleInputChange = (event) => {
        this.setState({ ResponseMessage: "" });
    } 
    render() {
        const { t } = this.props;
        return (this.state.ForgotPassword == true ? < React.Fragment >
            <p className="text-white mt-4 mb-4 font-24 font-thin text-center "><Trans>Request Forgotten Password</Trans></p>
            {/*11/11/22, PS_WW-538_01 - Adding the maxlength as 30 characters for the user ID, Dhevanesam R]*/}
            <div className="user-id position-relative">
                <input type="text" className="form-control font-12 login-control custom-margin changeevent pb-1" maxLength="30" id="UserId" placeholder={t("Enter Login Id")} autoFocus defaultValue={this.state.LoginUserId} onChange={this.handleInputChange} />

            </div>

            {/*15/08/23, 3968 - Adding the maxlength as 30 characters for the EmailID, Vishwa S]*/}
            <div className="Email position-relative"><input type="text" className="form-control font-12 login-control mb-1 changeevent pb-1" id="EmailID" maxLength="30" onKeyDown={this.restrictEnterAndTab} onChange={this.handleInputChange} placeholder={t("Enter Email Address")} />

            </div>
            <div><span className="float-left err-msg text-danger mb-2" id="ErrorMsg2"><Trans>{this.state.ResponseMessage}</Trans></span></div>
            <button className="btn btn-primary custom-btn-primary col-12 text-center login-btn mt-2" onClick={this.resetPwdBtn_Clk}><Trans>Reset Password</Trans></button>
            <p className="col-12 p-0 float-left text-left mt-3 password-info mb-0"><Trans>Password will be reset and sent to the email address that was set up in the Login profile for the Login ID entered above.</Trans></p>
            {/*04/06/2024, pc-4139-01, s.sanjay */}
            <div className="col-12 text-center float-left" ><Link className="mt-2  forgot-pw text-center " onClick={this.backToLoginClick}><Trans>Back To Login</Trans></Link></div>
            < div className="modal" id="forgetpassword" >
                <div className="modal-dialog modal-md custom-popup modal-dialog-centered">
                    <div className="modal-content">


                        {/* Modal body */}
                        <div className="modal-body">
                            <div className="row text-center">

                                <div className="col-12 mb-4">

                                    <label className="confirm-content d-block"><Trans>Are you sure you want to reset your password?</Trans></label>
                                </div>
                                <div className="col-md-12 text-center mb-2">
                                    <button className="btn btn-secondary custom-btn-secondary secondary-btn mr-3 px-4" data-dismiss="modal"><Trans>No</Trans></button>
                                    <button className="btn btn-primary custom-btn-primary primary-btn px-4" data-dismiss="modal" onClick={() => this.forgetPasswordOk_Clk()}><Trans>Yes</Trans></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </React.Fragment > : null)

    }
}
export default withTranslation()(ForgotPassword);

